<div fxLayout="row" fxLayoutAlign="start start" ngClass.sm="layout padding-left-m" ngClass.md="layout padding-left-m">
  <a href="#" (click)="$event.preventDefault();">
    <span fxHide.xs>Logs</span>
    <mat-icon fxHide.gt-xs>chevron_left</mat-icon>
  </a>
</div>